import { getOrderDetails } from "../api/orders";
import { flushAllProductChanges } from "./productSyncQueue";
import {
  initRequestPayments,
  updateOrder,
  updateClient,
  updateRequestIsOrder,
  updateRequestIsRecoveredCart,
  requestOrderCheckout,
  setComponentActive,
} from "../reducers/userConfigSlice";

import { canRecoverOrder, isHomeDeliveryOrder } from "../utils/orderState";
export { canEditConfirmedOrder, canRecoverOrder } from "../utils/orderState";
export const recoverOrderToTpv = async ({
  orderId,
  dispatch,
  checkout = false,
  shippingMethods = [],
}) => {
  if (!(await flushAllProductChanges()))
    throw Error(
      "Hay cambios sin guardar en el TPV. Espera a que se guarden antes de traer otro pedido.",
    );
  const response = await getOrderDetails(orderId);
  const order = response?.data?.order || response?.data;
  if (response?.error !== false || order?.orderId !== orderId)
    throw Error(
      "No se pudo actualizar el pedido. La comanda actual se conserva.",
    );
  if (!canRecoverOrder(order))
    throw Error(
      "Este pedido ya no está pendiente de cobro o no está disponible para el TPV.",
    );
  if (checkout && isHomeDeliveryOrder(order, shippingMethods))
    throw Error(
      "El reparto a domicilio lo cobra el repartidor. Puedes traerlo al TPV para consultarlo.",
    );
  const customer = order.Customer || order.customer || {};
  const address = order.address;
  const existing = customer.addresses || {};
  // Selecting a confirmed order does not clear or write the active basket.
  dispatch(initRequestPayments());
  dispatch(
    updateClient({
      ...customer,
      customerId: customer.customerId || order.customerId,
      addresses: {
        ...existing,
        shippingAddresses: address
          ? [address]
          : existing.shippingAddresses || [],
        addresses: address ? [address] : existing.addresses || [],
      },
    }),
  );
  dispatch(updateOrder(order));
  dispatch(updateRequestIsOrder(true));
  dispatch(updateRequestIsRecoveredCart(false));
  dispatch(requestOrderCheckout(checkout ? orderId : null));
  dispatch(setComponentActive("commander"));
  return order;
};
